import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SelecionarFranquiaComponent } from './selecionar-franquia.component';

@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: SelecionarFranquiaComponent }
    ])],
    exports: [RouterModule]
})
export class SelecionarFranquiaRoutingModule { }
